import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'

export default function (string) {
  return upperFirst(camelCase(string))
}



// WEBPACK FOOTER //
// ./src/utils/pascalCase.js